import KeenSlider from "keen-slider";
import { SliderConfig } from "../composables/use-keen-slider-config";
import { nextTick, watch } from "vue";
import { useNgSession } from "@sazka/ng/ng-session";

export const useTicketsSlider = ({
    container,
    buttonLeft,
    buttonRight,
    sliderConfig,
    updateOnLogout = false,
}: {
    container: HTMLElement;
    buttonLeft: HTMLElement;
    buttonRight: HTMLElement;
    sliderConfig: SliderConfig;
    updateOnLogout?: boolean;
}) => {
    if (!container || !buttonLeft || !buttonRight) return;

    const { config, areButtonsVisible, isButtonLeftDisabled, isButtonRightDisabled, handleSlideChanged } = sliderConfig;

    const slider = new KeenSlider(container, {
        ...config,
        created: (s) => {
            s.container.classList.remove("loading");
            handleSlideChanged(s);
        },
    });

    const prevButton = buttonLeft;
    const nextButton = buttonRight;
    const buttonParent = prevButton?.parentElement;

    watch(
        areButtonsVisible,
        (isVisible) => {
            if (isVisible) {
                buttonParent.classList.remove("hidden");
            } else {
                buttonParent.classList.add("hidden");
            }
        },
        { immediate: true }
    );

    watch(
        isButtonLeftDisabled,
        (isDisabled) => {
            if (isDisabled) {
                prevButton.setAttribute("disabled", "true");
            } else {
                prevButton.removeAttribute("disabled");
            }
        },
        { immediate: true }
    );

    watch(
        isButtonRightDisabled,
        (isDisabled) => {
            if (isDisabled) {
                nextButton.setAttribute("disabled", "true");
            } else {
                nextButton.removeAttribute("disabled");
            }
        },
        { immediate: true }
    );

    prevButton.addEventListener("click", () => slider.prev());
    nextButton.addEventListener("click", () => slider.next());

    if (updateOnLogout) {
        const { isLoggedIn } = useNgSession();
        watch(isLoggedIn, () => {
            if (!isLoggedIn.value) {
                nextTick(() => {
                    slider.update();
                });
            }
        });
    }

    return slider;
};
